// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37NiO","index":"styles_index__HFIbZ"};